export default {
    base_page: {
        title: '想为您的房源安装这样的预订模块吗？',
        description: '此预订模块由 RealtyCalendar 创建',
        button: '了解更多',
    },
    common: {
        months: [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月',
        ],
        back: '返回',
        book: '预订',
        more: '了解更多',
        from: '起',
        find: '查找',
        reset: '重置',
        apply: '应用',
        cancel: '取消',
        close: '关闭',
        print: '打印',
        change: '更改',
        arrival: '入住',
        by_list: '列表',
        by_map: '地图',
        download_confirmation: '下载预订确认单',
        guests: {
            adults: '成人',
            child: '儿童：',
            add_child: '添加儿童',
            guest: '{count} 位客人 | {count} 位客人 | {count} 位客人 | {count} 位客人 | {count} 位客人',
            child_count: '{count} 名儿童 | {count} 名儿童 | {count} 名儿童 | {count} 名儿童 | {count} 名儿童',
            list: '客人名单',
        },
        confirm_close: {
            title: '确定要关闭窗口吗？',
            text: '关闭后，您的预订数据将会丢失。',
        },
        meta: {
            title: '预订模块',
            description: '理想住宿正等着您，只需几秒即可预订！',
        },
        select_date: '选择日期',
        departure: '退房',
        refresh: '刷新',
        year: '{count} 年 | {count} 年 | {count} 年 | {count} 年 | {count} 年',
    },
    calendar: {
        check_in: '入住',
        check_out: '退房',
        check_in_check_out: '入住–退房',
        select_date: '请选择日期',
        select_check_in_date: '请选择入住日期',
        select_check_out_date: '请选择退房日期',
        departure_only_hint: '仅可退房',
        check_in_date_with_time: '入住 {date} - 请选择退房日期',
        check_in_check_out_dates: '入住 {checkIn} - 退房 {checkOut}',
        check_in_date: '入住日期',
        check_out_date: '退房日期',
        booking_min_days: '最少预订 {days} 天',
        discount_days: '{days} 天起享受折扣',
        while_staying: '入住时',
    },
    basket: {
        title: '预订',
        arrival_time: '入住时间',
        departure_time: '退房时间',
        select_time: '请选择时间',
        booking_params: '预订信息',
        form: {
            first_name: '名',
            last_name: '姓',
            phone: '电话',
            additional_phone: '备用电话（可选）',
            email: '邮箱',
            email_optional: '邮箱（可选）',
            wishes: '您的备注（可选）',
            enter_name: '请输入名',
            enter_last_name: '请输入姓',
            enter_phone: '请输入电话号码',
            enter_email: '请输入邮箱',
            placeholder_wishes: '给房东留言',
        },
        price: {
            cost: '费用',
            select_tariff: '请选择费率',
            stay_amount: '金额{period}',
            total: '合计',
            long_stay_discount: '长住优惠',
            rate_discount: '资费优惠',
            promo_code_discount: '优惠码折扣',
            processing_fee: '支付处理',
            payment_system_fee: '支付系统手续费',
            service_fee: '服务费',
            service_fee_tooltip: '款项将先进入支付服务商账户，并在您退房后转给房东。服务费用于保障交易安全并保护您作为住客的权益。',
            pay_now: '现在需支付金额',
            pay_later: '入住时支付',
            pay_later_tooltip: '房东会提前与您联系并说明如何付款。部分房东也可能要求支付押金。',
            select_dates_and_guests: '请选择入住、退房日期及客人数',
            payment_method: {
                title: '支付方式',
                sbp: 'SBP',
                card: '银行卡',
            },
        },
        agreement: {
            text: `我同意{consentLink}个人数据处理{/consentLink}，
        并确认我已阅读{bookingRulesLink}预订规则{/bookingRulesLink}、
        {safeTransactionsLink}无风险转账{/safeTransactionsLink}要约条款
        以及{privacyLink}个人数据处理政策{/privacyLink}。`,
            consent_text: `我同意{consentLink}个人数据处理{/consentLink}。`,
            rules_text: `我确认已阅读{bookingRulesLink}预订规则{/bookingRulesLink}、{safeTransactionsLink}无风险转账{/safeTransactionsLink}要约条款以及{privacyLink}个人数据处理政策{/privacyLink}。`,
            safe_transactions: '安全转账',
            privacy_policy: '个人信息处理政策',
            accommodation_rules: '住宿规则',
            booking_rules: '预订规则',
            foreign: {
                text: `我同意{agreementLink}预订条款、住宿规则和隐私政策{/agreementLink}。`,
            },
        },
        validation: {
            enter_check_in_date: '请选择入住日期',
            enter_check_out_date: '请选择退房日期',
            enter_name_required: '请输入名',
            name_min_length: '名至少需要 2 个字符',
            name_letters_only: '名只能包含字母',
            enter_last_name_required: '请输入姓',
            last_name_min_length: '姓至少需要 2 个字符',
            last_name_letters_only: '姓只能包含字母',
            enter_phone_required: '请输入电话号码',
            phone_invalid: '请输入有效的电话号码',
            enter_email_required: '请输入邮箱',
            email_invalid: '请输入有效的邮箱',
        },
        payment: {
            timer_text: '请尽快完成预付款，以确保房源仍然可订。您将被跳转到支付页面。支付完成后，房源将为您保留。',
        },
        promocode: {
            enter_promocode: '输入优惠码',
            promocode: '优惠码',
            enter_code: '请输入优惠码',
            discount: '优惠码折扣',
        },
    },
    hotel: {
        details: {
            description: '描述',
            amenities: '您将享有的设施',
            show_all_amenities: '查看全部设施：{count}',
            address: '地址',
            classification_certificate: '等级评定证书编号 {number}',
        },
        apartment: {
            room: '{count} 间 | {count} 间 | {count} 间 | {count} 间 | {count} 间',
            bed: '{count} 个床位 | {count} 个床位 | {count} 个床位 | {count} 个床位 | {count} 个床位',
            available_dates: '可用日期',
            date_range_sold_out: '{range} 已售罄。',
            select_free_dates: '请在日历中选择可用日期。',
            booking_available_from: '可预订起住 {minStay} 晚。',
            date_range_on: '在 {range}',
            rooms: '房间数',
            area: '面积',
            floor: '楼层',
            beds: '床位数',
            day_off: '{count} 天内 | {count} 天内 | {count} 天内 | {count} 天内 | {count} 天内',
            night_off: '{count} 晚 | {count} 晚 | {count} 晚 | {count} 晚 | {count} 晚',
        },
        map: {
            found: '已找到',
            scroll: '向下滚动查看全部',
            variant: '{count} 个选项 | {count} 个选项 | {count} 个选项 | {count} 个选项 | {count} 个选项',
            metro: '地铁',
        },
    },
    room_attributes: {
        washing_machine: '洗衣机',
        wi_fi: 'Wi-Fi',
        tv: '电视',
        air_conditioning: '空调',
        refrigerator: '冰箱',
        dishwasher: '洗碗机',
        music_center: '音响',
        microwave: '微波炉',
        iron: '熨斗和熨衣板',
        concierge: '礼宾服务',
        parking: '停车位',
        safe: '保险箱',
        waterheater: '热水器',
        bathroom: '洗浴用品',
        animals: '可带宠物',
        smoke: '可吸烟',
        balcony: '阳台',
        elevator: '电梯',
        romantic: '适合浪漫之旅',
        jacuzzi: '带按摩浴缸',
        kids: '可带儿童',
        party: '可举办活动',
        telephone: '电话',
        stove: '炉灶',
        cabletv: '有线电视',
        pool: '游泳池',
        seafront: '海滨一线',
        playground: '儿童游乐场',
        sauna: '桑拿/浴室',
        transfer: '接送服务',
        seaview: '海景',
        mountainview: '山景',
        crib: '婴儿床',
    },
    error: {
        map_loading_failed: '无法加载所有可用房源。',
        no_rooms: '暂无空房',
        no_rooms_text: '所选日期未找到可用房源。请联系我们——我们总能为您推荐其他选择！',
        occurred: '发生错误',
        booking_error_text: '出现问题，请联系我们：',
        connect_error_text: '搜索过程中与服务器的连接中断，请重试。',
        return_to_apartments: '返回房源列表',
        validation: '校验错误',
        not_found: '出了点问题，此页面不存在',
    },
    success: {
        booked: '已预订',
        thanks: '感谢您！您已成功预订 {address}',
        booking_info: '预订信息',
        check_in: '入住',
        check_out: '退房',
        amount: '金额',
        prepaid: '已支付预付款',
        pay_on_arrival: '到店补付',
        message_for_you: '给您的信息',
        check_in_date_time: '{date}，{timeStart}–{timeEnd}',
        check_out_date_time: '{date}，{timeStart}–{timeEnd}',
        notifications: {
            title: '免费通知',
            description: '我们会发送与您的预订相关的重要信息',
            connect_button: '在 Telegram 中连接',
        },
    },
    days: {
        day: '{count} 天 | {count} 天 | {count} 天 | {count} 天 | {count} 天',
    },
    loader: {
        loading: '正在加载…',
        searching: '正在查找可用选项…',
        checking: '正在核对价格…',
    },
    rules: {
        privacy_policy: '个人信息处理政策',
        accommodation_rules: '住宿规则',
        booking_rules: '预订规则',
        consent: {
            title: '个人数据处理同意书',
            title2: '个人数据处理政策',
            text: `Настоящим, я, действуя свободно, своей волей и в своем интересе, а также подтверждая свою дееспособность, предоставляя данные о себе, даю согласие {legalName}, ИНН {inn}, (далее – Оператор) на обработку следующих моих персональных данных, указанных мною при бронировании Проживания на сайте https://homereserve.ru или иным способом, с целью оформления и исполнения бронирования Проживания, в том числе оказания дополнительных услуг в Средстве/Объекте размещения Оператора: {<br>}

                    - фамилия, имя, отчество (при наличии); {<br>}
                    - контактная информация (номер телефона, адрес электронной почты); {<br>}
                    - гражданство; {<br>}
                    - дата рождения (число/месяц/год); {<br>}
                    - данные документа, удостоверяющего личность (серия, номер, дата выдачи, код подразделения, орган, выдавший документ, 
                    страна рождения, регион рождения, район, город, населенный пункт); {<br>}
                    - пол;  {<br>}
                    - адрес регистрации; {<br>}
                    - информация о гостях и их персональные данные. {<br>}

                    Для достижения указанной цели Оператор может осуществлять любые действия (операции) или совокупности действий (операций), 
                    совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, указанными выше,
                    включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, 
                    передачу (предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных. {<br>}

                    Я даю согласие Оператору на передачу (предоставление, доступ) персональных данных, указанных выше, в адрес следующего юридического лица, действующего по поручению Оператора: ООО «Апартмент системс», ИНН 7729748911 ОГРН 1137746760381, юридический адрес: 119607, г. Москва, ул. Раменки, д. 25 к. 3, кв. 668, а также иным третьим лицам через ООО «Апартмент системс» (для целей интеграции с системами бронирования, CRM-системами) в целях автоматизации бизнес-процессов, централизованного хранения и управления данными, а также осуществление с ними следующих действий (операций): сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (предоставление, доступ), обезличивание, блокирование, удаление, уничтожение. {<br>}
                    
                    Я подтверждаю, что предоставленные мной персональные данные являются точными, актуальными и достоверными, 
                    также обязуюсь своевременно информировать Оператора об изменениях в моих персональных данных по адресу электронной почты: 
                    {legalEmail}, либо в письменной форме на адрес: {legalAddress}. {<br>}

                    Настоящим подтверждаю, что в случае оформления мною заказа для третьих лиц, предоставляю персональные данные с их согласия. {<br>}
                    Настоящее согласие вступает в силу с момента его предоставления, путем проставления галочки на сайте https://homereserve.ru. {<br>}
                    Согласие действует до факта достижения цели обработки или до отзыва согласия. {<br>}

                    В соответствии с положениями ч. 2 ст. 9 Федерального закона от 27 июля 2006 г. № 152-ФЗ «О персональных данных», 
                    оставляю за собой право отозвать данное согласие посредством направления такого отзыва по адресу электронной почты: 
                    {legalEmail}, либо в письменной форме на адрес: {legalAddress}. {<br>}

                    Я предупрежден(а), что в случае отзыва согласия на обработку персональных данных Оператор вправе продолжить обработку 
                    персональных данных без согласия при наличии оснований, указанных в пп. 2-11 ч. 1 ст. 6, ч. 2 ст. 10 
                    Федерального закона от 27 июля 2006 г. № 152-ФЗ «О персональных данных»`,
        },
        privacy: {
            title: '个人数据处理政策',
            text: `1.ОБЩИЕ ПОЛОЖЕНИЯ {<br>}

                    1.1.Настоящая Политика в отношении обработки персональных данных (далее – Политика) разработана во исполнение требований п. 2 ч. 1 ст. 18.1 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных» в целях обеспечения защиты прав и свобод человека и гражданина при обработке его персональных данных, в том числе, защиты прав на неприкосновенность частной жизни, личную и семейную тайну. {<br>}
                    1.2.Политика действует в отношении всех персональных данных, которые обрабатывает {legalName}, ИНН {inn} (далее – Оператор). {<br>}
                    1.3.Политика распространяется на отношения в области обработки персональных данных, возникшие у Оператора как до, так и после утверждения Политики. {<br>}
                    1.4.Во исполнение требований ч. 2 ст. 18.1 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных», Политика публикуется в личном кабинете Оператора в RealtyCalendar. {<br>}

                    2.ОСНОВНЫЕ ПОНЯТИЯ, ИСПОЛЬЗУЕМЫЕ В ПОЛИТИКЕ {<br>}

                    2.1.Персональные данные – любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных); {<br>}
                    2.2.Оператор персональных данных (оператор) – государственный орган, муниципальный орган, юридическое или физическое лицо, самостоятельно или совместно с другими лицами организующие и (или) осуществляющие обработку персональных данных, а также определяющие цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными; {<br>}
                    2.3.Обработка персональных данных – любое действие (операция) или совокупность действий (операций) с персональными данными, совершаемых с использованием средств автоматизации или без их использования. Обработка персональных данных включает в себя в том числе: {<br>}
                    2.3.1.сбор; {<br>}
                    2.3.2.запись; {<br>}
                    2.3.3.систематизацию; {<br>}
                    2.3.4.накопление; {<br>}
                    2.3.5.хранение; {<br>}
                    2.3.6.уточнение (обновление, изменение); {<br>}
                    2.3.7.извлечение; {<br>}
                    2.3.8.использование; {<br>}
                    2.3.9.передачу (распространение, предоставление, доступ); {<br>}
                    2.3.10.обезличивание; {<br>}
                    2.3.11.блокирование; {<br>}
                    2.3.12.удаление; {<br>}
                    2.3.13.уничтожение. {<br>}
                    2.4.Автоматизированная обработка персональных данных – обработка персональных данных с помощью средств вычислительной техники; {<br>}
                    2.5.Распространение персональных данных – действия, направленные на раскрытие персональных данных неопределенному кругу лиц; {<br>}
                    2.6.Предоставление персональных данных – действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц; {<br>}
                    2.7.Блокирование персональных данных – временное прекращение обработки персональных данных (за исключением случаев, если обработка необходима для уточнения персональных данных); {<br>}
                    2.8.Уничтожение персональных данных – действия, в результате которых становится невозможным восстановить содержание персональных данных в информационной системе персональных данных и (или) в результате которых уничтожаются материальные носители персональных данных; {<br>}
                    2.9.Обезличивание персональных данных – действия, в результате которых становится невозможным без использования дополнительной информации определить принадлежность персональных данных конкретному субъекту персональных данных; {<br>}
                    2.10.Информационная система персональных данных – совокупность содержащихся в базах данных персональных данных и обеспечивающих их обработку информационных технологий и технических средств; {<br>}
                    2.11.Трансграничная передача персональных данных – передача персональных данных на территорию иностранного государства органу власти иностранного государства, иностранному физическому лицу или иностранному юридическому лицу. {<br>}

                    3.ОСНОВНЫЕ ПРАВА И ОБЯЗАННОСТИ ОПЕРАТОРА {<br>}

                    3.1.Оператор имеет право: {<br>}
                    3.1.1.самостоятельно определять состав и перечень мер, необходимых и достаточных для обеспечения выполнения обязанностей, предусмотренных Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных» и принятыми в соответствии с ним нормативными правовыми актами, если иное не предусмотрено Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных» или другими федеральными законами; {<br>}
                    3.1.2.поручить обработку персональных данных другому лицу с согласия субъекта персональных данных, если иное не предусмотрено федеральным законом, на основании заключаемого с этим лицом договора. Лицо, осуществляющее обработку персональных данных по поручению Оператора, обязано соблюдать принципы и правила обработки персональных данных, предусмотренные Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных»; {<br>}
                    3.1.3.в случае отзыва субъектом персональных данных согласия на обработку персональных данных Оператор вправе продолжить обработку персональных данных без согласия субъекта персональных данных при наличии оснований, указанных в Федеральном законе от 27.07.2006 г. № 152-ФЗ «О персональных данных». {<br>}
                    3.2. Оператор обязан: {<br>}
                    3.2.1.организовывать обработку персональных данных в соответствии с требованиями Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных»; {<br>}
                    3.2.2.отвечать на обращения и запросы субъектов персональных данных и их законных представителей в соответствии с требованиями Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных»; {<br>}
                    3.2.3.сообщать в уполномоченный орган по защите прав субъектов персональных данных (Федеральную службу по надзору в сфере связи, информационных технологий и массовых коммуникаций (Роскомнадзор)) по запросу этого органа необходимую информацию в течение 10 (десяти) рабочих дней с даты получения такого запроса. {<br>}

                    4.ОСНОВНЫЕ ПРАВА СУБЪЕКТА ПЕРСОНАЛЬНЫХ ДАННЫХ {<br>}

                    4.1.Субъект персональных данных имеет право: {<br>}
                    4.1.1.получать информацию, касающуюся обработки его персональных данных, за исключением случаев, предусмотренных федеральными законами. Сведения предоставляются субъекту персональных данных Оператором в доступной форме, и в них не должны содержаться персональные данные, относящиеся к другим субъектам персональных данных, за исключением случаев, когда имеются законные основания для раскрытия таких персональных данных. Перечень информации и порядок ее получения установлен Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных»; {<br>}
                    4.1.2.требовать от оператора уточнения его персональных данных, их блокирования или уничтожения в случае, если персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки, а также принимать предусмотренные законом меры по защите своих прав; {<br>}
                    4.1.3.выдвигать условие предварительного согласия при обработке персональных данных в целях продвижения на рынке товаров, работ и услуг; {<br>}
                    4.1.4.обжаловать в административном или судебном порядке неправомерные действия или бездействие Оператора при обработке его персональных данных. {<br>}
                    4.2. Контроль за исполнением требований настоящей Политики осуществляется Оператором или уполномоченным лицом, ответственным за организацию обработки персональных данных у Оператора. {<br>}
                    4.3. Ответственность за нарушение требований законодательства Российской Федерации и локальных нормативных актов Оператора в сфере обработки и защиты персональных данных определяется в соответствии с законодательством Российской Федерации. {<br>}

                    5.ЦЕЛИ СБОРА ПЕРСОНАЛЬНЫХ ДАННЫХ {<br>}

                    5.1.Обработка персональных данных ограничивается достижением конкретных, заранее определенных и законных целей. Не допускается обработка персональных данных, несовместимая с целями сбора персональных данных. {<br>}
                    5.2.Обработке подлежат только персональные данные, которые отвечают целям их обработки. {<br>}
                    5.3.Обработка Оператором персональных данных осуществляется в следующих целях: {<br>}
                    5.3.1.обеспечение соблюдения Конституции Российской Федерации, федеральных законов и иных нормативных правовых актов Российской Федерации; {<br>}
                    5.3.2.осуществление деятельности Оператора; {<br>}
                    5.3.3.ведение делопроизводства; {<br>}
                    5.3.4.заполнение и передача в органы исполнительной власти и иные уполномоченные организации требуемых форм отчетности; {<br>}
                    5.3.5.осуществление гражданско-правовых отношений; {<br>}
                    5.3.6.ведение бухгалтерского учета. {<br>}

                    6.ОБЪЕМ И КАТЕГОРИИ ОБРАБАТЫВАЕМЫХ ПЕРСОНАЛЬНЫХ ДАННЫХ, КАТЕГОРИИ СУБЪЕКТОВ ПЕРСОНАЛЬНЫХ ДАННЫХ {<br>}

                    6.1.Оператор может обрабатывать персональные данные следующих категорий субъектов персональных данных. {<br>}
                    6.1.1.Клиенты и контрагенты Оператора (физические лица): {<br>}
                    - фамилия, имя, отчество (при наличии); {<br>}
                    - контактная информация (номер телефона, адрес электронной почты); {<br>}
                    - гражданство; {<br>}
                    - дата рождения (число/месяц/год); {<br>}
                    - данные документа, удостоверяющего личность (серия, номер, дата выдачи, код подразделения, орган, выдавший документ, страна рождения, регион рождения, район, город, населенный пункт); {<br>}
                    - пол; {<br>}
                    - адрес регистрации; {<br>}
                    - информация о гостях и их персональные данные. {<br>}
                    6.2.Обработка Оператором биометрических персональных данных (сведений, которые характеризуют физиологические и биологические особенности человека, на основании которых можно установить его личность) не осуществляется. {<br>}
                    6.3.Оператором не осуществляется обработка специальных категорий персональных данных, касающихся расовой, национальной принадлежности, политических взглядов, религиозных или философских убеждений, состояния здоровья, интимной жизни, за исключением случаев, предусмотренных законодательством РФ. {<br>}

                    7.ПОРЯДОК И УСЛОВИЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ {<br>}

                    7.1.Обработка персональных данных осуществляется Оператором в соответствии с требованиями законодательства Российской Федерации. {<br>}
                    7.2.Обработка персональных данных осуществляется с согласия субъектов персональных данных на обработку их персональных данных, а также без такового в случаях, предусмотренных законодательством Российской Федерации. {<br>}
                    7.3.Оператор осуществляет как автоматизированную, так и неавтоматизированную обработку персональных данных. {<br>}
                    7.4.К обработке персональных данных допускаются работники Оператора, в должностные обязанности которых входит обработка персональных данных. {<br>}
                    7.5.Обработка персональных данных осуществляется путем: {<br>}
                    7.5.1.получения персональных данных в устной и письменной форме непосредственно от субъектов персональных данных; {<br>}
                    7.5.2.получения персональных данных из общедоступных источников; {<br>}
                    7.5.3.внесения персональных данных в журналы, реестры и информационные системы Оператора; {<br>}
                    7.5.4.использования иных способов обработки персональных данных. {<br>}
                    7.6.Не допускается раскрытие третьим лицам и распространение персональных данных без согласия субъекта персональных данных, если иное не предусмотрено федеральным законом. Согласие на обработку персональных данных, разрешенных субъектом персональных данных для распространения, оформляется отдельно от иных согласий субъекта персональных данных на обработку его персональных данных. {<br>}
                    Требования к содержанию согласия на обработку персональных данных, разрешенных субъектом персональных данных для распространения, утверждены Приказом Роскомнадзора от 24.02.2021 г. № 18 (а в случае его отмены в последующем – в заменяющем его нормативно-правовом акте). {<br>}
                    7.7.Передача персональных данных органам дознания и следствия, в Федеральную налоговую службу, Социальный фонд Российской Федерации и другие уполномоченные органы исполнительной власти и организации осуществляется в соответствии с требованиями законодательства Российской Федерации. {<br>}
                    7.8.Оператор принимает необходимые правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, распространения и других несанкционированных действий, в том числе: {<br>}
                    - определяет угрозы безопасности персональных данных при их обработке; {<br>}
                    - принимает локальные нормативные акты и иные документы, регулирующие отношения в сфере обработки и защиты персональных данных; {<br>}
                    - назначает лиц, ответственных за обеспечение безопасности персональных данных в структурных подразделениях и информационных системах Оператора; {<br>}
                    - создает необходимые условия для работы с персональными данными; {<br>}
                    - организует учет документов, содержащих персональные данные; {<br>}
                    - организует работу с информационными системами, в которых обрабатываются персональные данные; {<br>}
                    - хранит персональные данные в условиях, при которых обеспечивается их сохранность и исключается неправомерный доступ к ним; {<br>}
                    - организует обучение работников Оператора, осуществляющих обработку персональных данных. {<br>}
                    7.9.Оператор осуществляет хранение персональных данных в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если срок хранения персональных данных не установлен федеральным законом, договором. {<br>}
                    7.10.При сборе персональных данных, в том числе посредством информационно-телекоммуникационной сети «Интернет», запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение персональных данных граждан Российской Федерации с использованием баз данных, находящихся за пределами территории Российской Федерации, не допускаются, за исключением случаев, указанных в пунктах 2, 3, 4, 8 части 1 статьи 6 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных». {<br>}

                    8.АКТУАЛИЗАЦИЯ, ИСПРАВЛЕНИЕ, УДАЛЕНИЕ И УНИЧТОЖЕНИЕ ПЕРСОНАЛЬНЫХ ДАННЫХ, ОТВЕТЫ НА ЗАПРОСЫ СУБЪЕКТОВ НА ДОСТУП К ПЕРСОНАЛЬНЫМ ДАННЫМ {<br>}

                    8.1.Подтверждение факта обработки персональных данных Оператором, правовые основания и цели обработки персональных данных, а также иные сведения, указанные в ч. 7 ст. 14 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных», предоставляются Оператором субъекту персональных данных или его представителю при обращении либо при получении запроса субъекта персональных данных или его представителя по адресу электронной почты: {legalEmail}, либо в письменной форме на адрес: {legalAddress}. {<br>}
                    В предоставляемые сведения не включаются персональные данные, относящиеся к другим субъектам персональных данных, за исключением случаев, когда имеются законные основания для раскрытия таких персональных данных. {<br>}
                    Запрос должен содержать: {<br>}
                    - номер основного документа, удостоверяющего личность субъекта персональных данных или его представителя, сведения о дате выдачи указанного документа и выдавшем его органе; {<br>}
                    - сведения, подтверждающие участие субъекта персональных данных в отношениях с Оператором (номер договора, дата заключения договора, условное словесное обозначение и (или) иные сведения), либо сведения, иным образом подтверждающие факт обработки персональных данных Оператором; {<br>}
                    - подпись субъекта персональных данных или его представителя. {<br>}
                    Запрос может быть направлен в форме электронного документа и подписан электронной подписью в соответствии с законодательством Российской Федерации. {<br>}
                    Если в обращении (запросе) субъекта персональных данных не отражены в соответствии с требованиями Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных» все необходимые сведения или субъект не обладает правами доступа к запрашиваемой информации, то ему направляется мотивированный отказ. {<br>}
                    Право субъекта персональных данных на доступ к его персональным данным может быть ограничено в соответствии с ч. 8 ст. 14 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных», в том числе, если доступ субъекта персональных данных к его персональным данным нарушает права и законные интересы третьих лиц. {<br>}
                    8.2.В случае выявления неточных персональных данных при обращении субъекта персональных данных или его представителя либо по их запросу или по запросу Роскомнадзора Оператор осуществляет блокирование персональных данных, относящихся к этому субъекту персональных данных, с момента такого обращения или получения указанного запроса на период проверки, если блокирование персональных данных не нарушает права и законные интересы субъекта персональных данных или третьих лиц. {<br>}
                    В случае подтверждения факта неточности персональных данных Оператор на основании сведений, представленных субъектом персональных данных или его представителем либо Роскомнадзором, или иных необходимых документов уточняет персональные данные в течение семи рабочих дней со дня представления таких сведений и снимает блокирование персональных данных. {<br>}
                    8.3.При достижении целей обработки персональных данных, а также в случае отзыва субъектом персональных данных согласия на их обработку персональные данные подлежат уничтожению, если: {<br>}
                    - иное не предусмотрено договором, стороной которого, выгодоприобретателем или поручителем, по которому является субъект персональных данных; {<br>}
                    - Оператор не вправе осуществлять обработку без согласия субъекта персональных данных на основаниях, предусмотренных Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных» или иными федеральными законами; {<br>}
                    - иное не предусмотрено другим соглашением между Оператором и субъектом персональных данных. {<br>}

                    9.ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ {<br>}

                    9.1.Политика вступает в силу с момента утверждения Оператором и действует бессрочно. {<br>}
                    9.2.Внесение изменений, дополнение или отмена Политики производится на основании принятия Оператором соответствующего решения. {<br>}`,
        },
        booking: {
            main: {
                title: '预订规则',
            },
            another: {
                title: '其他预订规则',
            },
            refund: {
                title: '预付款退款规则',
            },
        },
        residence: {
            title: '入住规则',
        },
        foreign_agreement: {
            title: '预订条款、住宿规则和隐私政策',
        },
    },
    hotels: {
        map: {
            close_list: '关闭列表',
        },
    },
    apartment: {
        arrival_departure_text: '入住时间 {in_start} 至 {in_end}，退房时间 {out_start} 至 {out_end}',
    },
    payment: {
        info: {
            error: {
                title: '链接已过期',
                description: '请联系您的经理：',
                agreement_required: '您需要同意要约条款',
            },
            check_in: '入住',
            check_out: '退房',
            amount: '总价',
            paid_amount: '已支付',
            amount_left: '待支付金额',
            time_from: '从 {from}',
            time_to: '至 {to}',
        },
        status: {
            success: '已支付',
            not_paid: '住宿未支付',
        },
    },
    gallery: {
        large_photo: '大照片',
        small_photo: '小照片',
        more_photos: '+{count} 张照片',
    },
};
